import { type FC, useEffect, useState } from 'react';

import { useNavigation } from 'react-router-dom';

import { tokens } from '@shared/styles/tokens';

import styles from './RouteProgress.module.css';

/**
 * Тонкая полоса сверху, пока роутер грузит код новой страницы (route.lazy держит старую на месте).
 * Появляется только после задержки: быстрый переход без мигания. Для скринридера — aria-busy
 * на main в MainLayout, сама полоса скрыта
 */
export const RouteProgress: FC = () => {
  const { state } = useNavigation();
  const motion = tokens.motion;
  const [visible, setVisible] = useState(false);
  const loading = state === 'loading';

  useEffect(() => {
    if (!loading) {
      setVisible(false);
      return;
    }
    const timer = window.setTimeout(() => setVisible(true), motion.progressDelayMs);
    return () => window.clearTimeout(timer);
  }, [loading, motion.progressDelayMs]);

  // loading — тоже условие: после перехода эффект сбросит visible только следующим рендером,
  // и полоса провисела бы кадр поверх новой страницы
  return loading && visible ? (
    <div className={styles.root} aria-hidden data-route-progress />
  ) : null;
};
